module.exports = __webpack_public_path__ + "static/media/banner1_m.d1e645c5.png";